module.exports = __webpack_public_path__ + "img/Visa.5867b17c.png";